<template>
  <div class="postHeader">
    <div v-if="isLogin" class="columns is-mobile is-gapless is-pulled-right">
      <div class="column is-half post-login-header">                            
        <es-dropdown :popStyle="{width: '350px', marginTop:'28px', marginRight: '-48px'}" :pushUp="'.header|#notificationsPopup'" position="right" >          
          <div class="menu-item gap notification-icon" v-on:click="hasReadControl()"></div>
          <div class="menu-item gap notification-icon-selected"></div>
          <div v-if="!hasRead" class="notification-count">{{ policies.length }}</div>
          <div class="menu-item-bar menu-item-bar-selected"></div>       
          <div slot="content" class="menu-content" id="notificationsPopup">
            <div class='info-text'>
              <div class="info-text-detail-paragraph">
                <div class="info-text-detail-header">
                  <Description title="Bildirimler" description=""/>
                </div>
                <div class="read-all">
                  <span v-if="policies.length === 0">Yeni bildiriminiz bulunmamaktadır</span>
                </div> 
                <div class="columns is-gapless is-multiline">
                  <div class="column is-12" v-for="polItem in policies">
                    <router-link :to="{name: 'Policies'}">
                      <div class="policy-item" v-if="policies.length > 0">{{ polItem.PoliceNo }}<span> nolu poliçenizin vadesi geçmiş borcu bulunmaktadır.</span></div>
                    </router-link>
                  </div>
                </div>
                <div class='divider'></div>
              </div>
            </div>
          </div>
        </es-dropdown>
      </div>
      <div class="column is-half post-login-header online-office" style="position: relative;" v-bind:class="{'selected': isPersonalTabActive}">
        <es-dropdown :popStyle="{width: '200px', marginTop:'28px', marginRight: '0px'}" :pushUp="'.header|#notificationsPopup'" position="right">
          <a id="online-office-button" class="">
            <div class="profile-icon menu-item gap" v-bind:class="{'profile-icon': !isPersonalTabActive, 'profile-icon-selected': isPersonalTabActive}"></div>                            
            <div class="menu-item-bar" v-bind:class="{'menu-item-bar-selected': isPersonalTabActive}"></div>             
          </a>               
          <div slot="content" class="menu-content">                                
            <div v-on:click="$router.push({ name: 'Personal' })">
              <button class="button is-light is-large is-fullwidth online-btn">{{ $t("links.onlineTransactions") }}</button>
            </div>            
            <div class="online-item" v-on:click="$router.push({ name: 'Profile'})">
              <p class='image-link'>{{ $t("texts.myProfile") }}</p>
            </div>
            <div class="online-item" v-on:click="$router.push({ name: 'Policies'})">
              <p class='image-link'>{{ $t("texts.myPolicies") }}</p>
            </div>
            <div class="online-item" v-on:click="$router.push({ name: 'Proposals'})">
              <p class='image-link'>{{ $t("texts.myProposals") }}</p>
            </div>
            <div class="online-item" v-on:click="$router.push({ name: 'Claims'})">
              <p class='image-link'>{{ $t("texts.myClaimFiles") }}</p>
            </div>
            <div class="log-out-text online-title">
              <a v-on:click.stop="logOut($event)">{{ $t("links.logOut") }}</a>
            </div>
          </div>
        </es-dropdown>        
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/service'
import Notifications from '@/shared/widget/post/notifications'
import EsDropdown from '@/shared/components/es-dropdown'
import Description from '@/shared/widget/proposal/description'
export default {
  name: 'PostHeader',
  components: {
    Notifications, EsDropdown, Description
  },
  data () {
    return {
      notificationActive: false,
      hasRead: false,
      notificationMessages: [],
      policies: []
      // personalActive: false
    }
  },
  mounted () {
    // if (this.isLogin() && this.isVGBPoliciesActive) {
    //   this.getVgbPolicies()
    // }
    this.notificationActive = (this.$route.name === 'Notifications')
    this.hasRead = window.getNotificationRead()
  },
  methods: {
    getVgbPolicies: function () {
      var self = this
      var req = {
        Token: window.getToken()
      }
      service.customer.getVgbPolicies(self, self.eventHub, false, req).then(function (data) {
        if (data.body.ResultType === 0) {
          var notifications = data.body.ReturnObject
          if (notifications.length > 0) {
            notifications.forEach(function (item) {
              self.policies.push(item)
            })
          }
        }
      })
    },
    hasReadControl: function () {
      this.hasRead = true
      window.setNotificationRead(this.hasRead)
    },
    logOut: function () {
      var self = this
      var data = {
        logOut: true
      }
      service.access.logOut(self, self.eventHub, true, data).then(function (resp) {
        if (resp.ok) {
          var loginInfo = JSON.parse(resp.bodyText)
          if (loginInfo && loginInfo.ResultType === 0) {
            window.deleteLoginItems()
            self.removeCustomerInfo()

            setTimeout(function () {
              self.eventHub.$emit('logout', {
                value: true
              })
            }, 500)
          }
        }
      })
    }
  },
  computed: {
    isPersonalTabActive () {
      return this.$route.meta.isPost && (this.$route.name !== 'Notifications')
    },
    isVGBPoliciesActive () {
      return window.location.hostname.indexOf('mtestv3') === 0 && window.location.hostname.indexOf('testv3') === 0 && window.location.hostname.indexOf('localhost') === 0
    }
  }
}
</script>
<style scoped>
.header {
  background: var(--eureko-blue);
  padding: 11px 15px 11px 15px;
  z-index: 101;
}

/*.profile-icon.menu-item.gap.profile-icon:hover, .menu-item.gap.notification-icon:hover {
  background-color: #0d60b8;
  border-radius: 4px;
}
.profile-icon.menu-item.gap.profile-icon {
  padding: 9px 9px 7px 9px;
  margin: 0 9px 0 9px;
}
.menu-item.gap.notification-icon {
  padding: 9px 12px 8px 12px;
  margin: 0 9px 0 9px;
}
*/
.menu-item {
  padding: 9px 18px 8px 18px;
}

.postHeader .menu-item.notification-icon, .postHeader .menu-item.notification-icon-selected, .postHeader .menu-item.profile-icon {
  cursor: pointer;
}
.active .menu-item-bar-selected {
  background-color: var(--btn-info);  
  display: block;
  width: 36px;
}
.menu-item-bar {
  height: 4px;
  margin-top: 13px;
  position: absolute;
  width: 36px;
  display: block;
}
.postHeader .active .notification-icon-selected {
  display: block;
}
.postHeader .active .notification-icon {
  display: none;
}
.postHeader .notification-icon-selected {
  display: none;
}
.postHeader .notification-icon {
  display: block;
}
.postHeader .notification-count {
  color: white;
  position: absolute;
  left: 17px;
  bottom: 15px;
  z-index: 100;
  width: 20px;
  height: 20px;
  background-color: #f43c39;
  font-size: 13px;
  border-radius: 50%;
  text-align: center;
  line-height: initial;
}
.postHeader .active .notification-count {
  display: none;
}
.postHeader .info-text {
  background-color: var(--light-bg2);
  height: 100%;
  padding: 10px 5px;
}
.postHeader .info-text .info-text-detail-paragraph {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--text-color1);
  margin: auto 11px auto 11px;
  height: 318px;
  overflow-y: scroll;
}
.postHeader .info-text .info-text-detail-paragraph .info-text-detail-header { 
  margin: 0 0 0.625em 0;
}
.postHeader .info-text .info-text-detail-paragraph .read-all {
  margin-bottom: 10px;
}
.postHeader .info-text .info-text-detail-paragraph .read-all a {
  font-size: 0.938em;
  font-weight: 500;
  text-decoration: underline;
  line-height: 1.29;
  letter-spacing: -0.3px;
  color: var(--text-color9) !important;
  text-align: center;
}
.postHeader .policy-item {
  cursor: pointer;
  padding: 10px 0;
}
</style>
<style>
.postHeader .notifications {
  max-width: 350px;
}
.postHeader .notifications .info-text {
  background-color: var(--light-bg1) !important;
  padding: 0 !important;
  margin: 10px 5px !important;
}
.postHeader .notifications .info-text .info-text-detail-paragraph .read-all a {
  text-decoration: none !important;
}
.postHeader .column.post-login-header .active, .postHeader .column.post-login-header:hover {
  background-color: var(--dark-bg4) !important;
  margin: -15px 0 !important;
  padding: 15px 0 !important;
}
.postHeader .column.post-login-header:hover {
  cursor: pointer;
}

#online-office-button {
  height: 44px;
}
.active .is-info {
  background-color: var(--btn-info-active);
}
.online-office .menu-content {
  padding:24px 30px;
}
.online-office .menu-content button {
  margin: 12px auto; 
}
.online-title {
  font-size: 0.875em;
  font-weight: 500;
  letter-spacing: -0.3px;
  color: var(--text-color1);
  padding: 15px 0;
}
.online-item {
  border-top:1px solid var(--border-color1);
  padding: 10px 0;
  font-size: 0.875em;
  line-height: 1.29;
  letter-spacing: -0.3px;
}
.online-item a, .online-item p {
  color: var(--text-color9);
}
.online-title a {
  color: var(--text-color1);
}

</style>


// WEBPACK FOOTER //
// src/desktop/widget/post/PostHeader.vue